/* src/app/components/lh-table/lh-table.component.scss */
ag-header-row ag-header-row-column ::ng-deep .ag-theme-material .ag-header-row {
  padding-right: 5px;
  padding-left: 10px;
}
ag-header-row ag-header-row-column ::ng-deep .ag-theme-material .ag-header-row .ag-header-cell {
  padding-left: 10px;
  padding-right: 5px;
}
ag-header-row ag-header-row-column ::ng-deep .ag-theme-material .ag-header-row .ag-header-cell[unselectable=on] {
  background-color: var(--ion-color-header-table-updated);
  color: var(--ion-color-white);
  font-weight: 700;
  font-size: 1.2em;
  padding-left: 10px;
  padding-right: 5px;
}
ag-header-row ag-header-row-column ::ng-deep .ag-theme-material .ag-header-row .ag-header-cell[unselectable=on]:hover {
  background: var(--ion-color-header-table-updated) !important;
  color: var(--ion-color-white);
  font-weight: 700;
  font-size: 1.2em;
}
ag-header-row ag-header-row-column ::ng-deep .ag-theme-material .ag-header-row .ag-icon {
  color: var(--ion-color-white);
}
ag-header-row ag-header-row-column ::ng-deep .ag-theme-material .ag-header-row .ag-header-group-cell-no-group {
  background-color: rgba(95, 80, 70, 0.2);
  color: black;
  font-size: 1.3em;
  font-weight: 700;
  pointer-events: none;
  padding: 0px 10px 0px 10px;
}
ag-header-row ag-header-row-column ::ng-deep .ag-theme-material .ag-header-row .ag-header-group-cell-with-group {
  background-color: rgba(95, 80, 70, 0.4);
  color: black;
  font-size: 1.3em;
  font-weight: 700;
  pointer-events: none;
  padding: 0px 10px 0px 10px;
}
ag-header-row ag-header-row-column ::ng-deep .ag-theme-material .ag-header-row .ag-icon-filter {
  color: rgb(0, 0, 0);
}
::ng-deep .ag-theme-material .ag-input-wrapper input:not([type]),
::ng-deep .ag-theme-material .ag-input-wrapper input[type=text],
::ng-deep .ag-theme-material .ag-input-wrapper input[type=number],
::ng-deep .ag-theme-material .ag-input-wrapper input[type=tel],
::ng-deep .ag-theme-material .ag-input-wrapper input[type=date],
::ng-deep .ag-theme-material .ag-input-wrapper input[type=datetime-local] {
  border: 1px solid #e2e2e2;
}
::ng-deep .ag-theme-material .ag-checkbox-input-wrapper {
  background-color: #ffffff;
}
::ng-deep .ag-theme-material .ag-checkbox-input-wrapper.ag-checked::after {
  color: var(--ion-color-header-table-updated) !important;
}
::ng-deep .ag-theme-material .ag-ltr .ag-header-select-all {
  padding-left: 15px;
}
::ng-deep .ag-theme-material .ag-checkbox-input-wrapper.ag-indeterminate {
  color: #ffffff !important;
  background-color: #ffffff !important;
  padding-left: 10px;
}
::ng-deep .ag-paging-page-size {
  visibility: hidden;
}
@media screen and (max-width: 900px) and (orientation: landscape) {
  ::ng-deep .ag-root-wrapper-body.ag-layout-normal {
    overflow: scroll !important;
  }
  ::ng-deep .ag-body-viewport.ag-layout-normal {
    overflow: visible;
  }
  ::ng-deep .ag-root.ag-layout-normal {
    overflow: visible;
  }
  ::ng-deep .ag-body-horizontal-scroll-viewport {
    overflow: hidden;
  }
  ::ng-deep .ag-paging-panel {
    max-height: 2em;
  }
}
::ng-deep .ag-theme-material .ag-header-row:not(.ag-header-row-column-filter) .ag-header-cell {
  background-color: var(--ion-color-header-table-updated) !important;
  color: #ffffff !important;
  font-weight: bold;
}
::ng-deep .ag-theme-material .ag-header-row.ag-header-row-column-filter {
  height: 42px !important;
  padding: 0 !important;
  margin: 0 !important;
}
::ng-deep .ag-theme-material .ag-header-row.ag-header-row-column-filter .ag-header-cell input {
  min-width: 100% !important;
  padding: 2px 6px !important;
  box-sizing: border-box;
  font-size: 12px !important;
  margin: 20px !important;
  height: 28px !important;
}
::ng-deep .ag-theme-material .ag-header-row.ag-header-row-column-filter .ag-header-cell {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
}
::ng-deep .ag-theme-material .ag-header-cell .ag-icon {
  color: white !important;
  fill: white !important;
}
::ng-deep .ag-theme-material .ag-header-cell .ag-sort-ascending-icon,
::ng-deep .ag-theme-material .ag-header-cell .ag-sort-descending-icon {
  color: white !important;
  fill: white !important;
}
::ng-deep .ag-theme-material .ag-header-group-cell-with-group {
  background-color: #d3d3d3 !important;
  color: #000 !important;
  font-weight: 600 !important;
  display: flex !important;
  text-align: center !important;
  justify-content: center !important;
  font-size: 13px !important;
  align-items: center !important;
}
::ng-deep .ag-theme-material .ag-header-group-cell-label {
  justify-content: center !important;
}
/*# sourceMappingURL=lh-table.component.css.map */
